import React, { useState } from 'react';
import images from '../../images';
import { apiRequest } from '../../api/index';
import { getUserIdFromStorage } from '../../api/auth.sso';

const ReplenishBalanceModal = ({ isOpen, onClose }) => {

  const [amount, setAmount] = useState('');
  const [invoiceGenerated, setInvoiceGenerated] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [modalSize, setModalSize] = useState('medium');

  const handleAmountChange = (e) => {
    if (!invoiceGenerated) {
      setAmount(e.target.value);
    }
  };

  const handleCreateInvoice = async () => {
    if (!amount || isNaN(amount) || amount <= 0) {
      alert('Пожалуйста, введите корректную сумму.');
      return;
    }

    try {
      const userID = getUserIdFromStorage();
      const formData = new FormData();
      formData.append('rekl_id', userID);
      formData.append('operation', 'in');
      formData.append('paid', parseFloat(amount));
      formData.append('descr', 'Пополнение баланса');

      const response = await apiRequest('invoice/add', 'POST', formData);
      console.log('Счет сформирован:', response);
      
      // Сохраняем данные ответа и переходим в режим "счет сформирован"
      setModalSize('medium-2');
      setInvoiceData(response.data);
      setInvoiceGenerated(true);
    } catch (error) {
      console.error('Ошибка при формировании счета:', error);
      // Можно добавить уведомление об ошибке
    }
  };

  const handleDownloadInvoice = async () => {
    if (!invoiceData || !invoiceData.id) {
      console.error('ID счета не найден');
      return;
    }
    
    try {
      // Используем apiRequest для скачивания файла
      const response = await apiRequest(`invoice/document?invoice_id=${invoiceData.id}`, 'GET', null, true);

      // Создаем объект URL из blob и инициируем скачивание
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      // Используем invoice_id в качестве имени файла
      link.setAttribute('download', `invoice_${invoiceData.id}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Ошибка при скачивании счета:', error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className={`modal ${modalSize} bottom-right open`} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>Пополнение баланса</h3>
        </div>
        <div className="modal-body">
          <p>Пополнить баланс на: </p>
          <div className="webhook-input-container">
            <img
                src={images.moneyLinear}
                alt=""
                className="webhook-icon"
            />
            <input
                type="number"
                placeholder="Введите сумму"
                className="webhook-input"
                value={amount}
                onChange={handleAmountChange}
                readOnly={invoiceGenerated}
            />
          </div>

          {invoiceGenerated && (
              <div className="invoice-info-block">
                <div className="invoice-icon-cell">
                  <img src={images.filesBroken} alt="" className="invoice-icon"/>
                </div>
                <div className="invoice-text-cell">
                  <h4 className="invoice-title">Счет готов</h4>
                  <p className="invoice-subtitle">После оплаты деньги зачислятся в течении 2-3 рабочих дней</p>
                  <p className="invoice-recipient">Получатель: ООО “ПартнерЛидс”</p>
                  <p className="invoice-offer">Оплачивая данный счет, Вы принимаете условие договора публичной оферты №3
                    от «01» апреля 2026, опубликованным на сайте <a
                        href="https://partnerlids.ru">https://partner-leeds.ru</a>. В случае несогласия с договором
                    публичной оферты, мы рекомендуем не оплачивать данный счет.</p>
                </div>
              </div>
          )}
        </div>
        <div className="modal-footer">
          {invoiceGenerated ? (
              <button className="btn btn-primary-filled" onClick={handleDownloadInvoice}>Скачать счет</button>
          ) : (
              <button className="btn btn-primary-filled" onClick={handleCreateInvoice}>Сформировать счет</button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReplenishBalanceModal;